import { Component } from "react";
import axios from "axios";
import { useNavigation } from '../../utilities/NavigationContext';

const formatDate = (iso) => {
  if (!iso) return "";
  const [datePart] = iso.split("T");       // "2025-11-16"
  const [y, m, d] = datePart.split("-");   // clean split
  return `${d}/${m}/${y}`;
};


const EndPoint = process.env.REACT_APP_API_ENDPOINT;

class CreditTopupSuccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      creditInfo: null,
      error: null,
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      this.setState({ loading: false, error: "Missing session_id" });
      return;
    }

    this.fetchCreditStatus(sessionId);
  }

  async fetchCreditStatus(sessionId) {
    try {
      const res = await axios.get(
        `${EndPoint}/stripe/credits/status?sessionId=${sessionId}`,
        { withCredentials: true }
      );

      this.setState({
        loading: false,
        creditInfo: res.data,
      });
    } catch (err) {
      console.error(
        'fetchCreditStatus error:',
        err.response?.status,
        err.response?.data || err.message
      );
      this.setState({
        loading: false,
        error: "Unable to retrieve credit purchase details",
      });
    }
  }

  goToPlan = () => {
    this.props.navigate('/planning'); 
  };

  goToCredits = () => {
    this.props.navigate('/pricing'); 
  };

  render() {
    const { loading, creditInfo, error } = this.state;

    if (loading) {
      return (
        <div className="p-5 text-center">
          <h2>Finalising your credit purchase…</h2>
        </div>
      );
    }

    if (error) {
      return (
        <div className="p-5 text-center">
          <h2>Error</h2>
          <p>{error}</p>

          <button onClick={this.goToCredits}>Try Again</button>
        </div>
      );
    }

    return (
      <div className="p-5 text-center bg-slate-100 text-md rounded shadow m-20">
        <h1 className='text-xl font-bold my-4'>Credits Added Successfully 🎉</h1>

        <p><b>Credits Purchased:</b> {creditInfo?.creditsAdded}</p>
        <p><b>Total Credits:</b> {creditInfo?.totalCredits}</p>
        <p><b>Purchase Date:</b> {formatDate(creditInfo?.purchaseDate)}</p>

        <div className='mt-20'>
          <button onClick={this.goToPlan} className='bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4 mr-4'>
            Go to Planning
          </button>
          <button onClick={this.goToCredits} className='bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4 mr-4'>Buy More Credits</button>
        </div>
      </div>
    );
  }
}


const CreditTopupSuccessWithNavigation = (props) => {
    const navigate = useNavigation();
    return <CreditTopupSuccess {...props} navigate={navigate} />;
};

export default CreditTopupSuccessWithNavigation;
